import http from '../http';
import {api} from '../api';
import {
  ConfigResponseType,
  ForgotPasswordResponse,
  LoginForm,
  LoginResponse,
  UpdateUserBody,
  UserDataType,
} from '../../interfaces/api/auth/login';
import {HttpHeaders, HttpResponse} from '../../interfaces/api/http';
import {objectToFormData} from '../../utils/form';
import {
  RegisterForm,
  RegisterResponse,
  ResendVerificationResponse,
} from '../../interfaces/api/auth/register';

export const auth = {
  login: (
    body: LoginForm,
    headers: HttpHeaders,
  ): Promise<HttpResponse<LoginResponse>> =>
    new Promise((resolve, reject) => {
      http
        .post<LoginResponse>(api.auth.login, body, headers)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  register: (
    body: RegisterForm,
    headers: HttpHeaders,
  ): Promise<HttpResponse<LoginResponse>> =>
    new Promise((resolve, reject) => {
      http
        .post<LoginResponse>(api.auth.register, body, headers)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  forgotPassword: (
    email: string,
  ): Promise<HttpResponse<ForgotPasswordResponse>> =>
    new Promise((resolve, reject) => {
      http
        .post<ForgotPasswordResponse>(
          api.auth.forgotPassword,
          {email},
          {},
          true,
        )
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  resetPassword: (body: {
    email: string;
    token: string;
    password: string;
  }): Promise<HttpResponse<ForgotPasswordResponse>> =>
    new Promise((resolve, reject) => {
      http
        .post<ForgotPasswordResponse>(
          api.auth.resetPassword,
          body,
          {},
          true,
        )
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  getConfig: (): Promise<HttpResponse<ConfigResponseType>> =>
    new Promise((resolve, reject) => {
      http
        .get<ConfigResponseType>(api.auth.config)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  updateUser: (body: UpdateUserBody): Promise<HttpResponse<UserDataType>> =>
    new Promise((resolve, reject) => {
      const formData = objectToFormData(body);
      http
        .post<UserDataType>(api.auth.updateUser, formData, {
          'Content-Type': 'multipart/form-data',
        })
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  resendVerification: (
    email: string,
  ): Promise<HttpResponse<ResendVerificationResponse>> =>
    new Promise((resolve, reject) => {
      http
        .post<ResendVerificationResponse>(
          api.auth.resendVerification,
          {email},
          {},
          true,
        )
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
};
